import { useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { resourceKeyAtom } from 'components/resources/resourceList/atoms'
import { EditableResourceList } from 'components/resources/resourceList/EditableResourceList'
import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import { PlainLink as Link } from 'infrastructure/routing'

export function Frameworks() {
  useSetAtom(resourceKeyAtom)('frameworks')
  return (
    <Box sx={{ backgroundColor: '#f5f5f5', p: 3, minHeight: '100vh' }}>
      <Button component={Link} to="/scope_and_sequence" size="small">
        &larr; Back to List
      </Button>
      <Typography variant="h5" fontWeight={700} sx={{ mt: 1 }}>
        Standards
      </Typography>
      <EditableResourceList navigateRows={false} />
    </Box>
  )
}
